(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalina-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalina-announcement-v4')) {
  customElements.define('catalina-announcement-v4', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.mount());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      clearTimeout(this.timer);
      this.events?.abort();
      this.barResize?.disconnect();
      this.releaseSticky();
      this.removeAttribute('data-ready');
    }
    mount() {
      if (!this.isConnected || this.dataset.ready === 'true') return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.slides = [...this.querySelectorAll('[data-cna-slide]')];
      this.pauseButton = this.querySelector('[data-cna-pause]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.userPaused = false;
      this.hovering = false;
      this.focused = false;
      this.editorSelected = false;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 6000);
      this.dataset.ready = 'true';
      this.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'touch') { this.hovering = true; this.schedule(); }
      }, {signal});
      this.addEventListener('pointerleave', () => { this.hovering = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {
        this.focused = this.contains(document.activeElement);
        this.schedule();
      }), {signal});
      this.pauseButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.schedule();
      }, {signal});
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.userPaused = true; this.schedule(); }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          this.userPaused = true;
          this.show((this.index + (e.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length);
        }
      }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.reduced.addEventListener('change', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', e => {
        const next = this.slides.findIndex(slide => slide.dataset.blockId === String(e.detail?.blockId));
        if (next < 0) return;
        this.editorSelected = true;
        this.show(next);
      }, {signal});
      document.addEventListener('shopify:block:deselect', e => {
        if (!this.slides.some(slide => slide.dataset.blockId === String(e.detail?.blockId))) return;
        this.editorSelected = false;
        this.schedule();
      }, {signal});
      document.addEventListener('shopify:section:select', e => {
        if (e.target?.contains(this)) { this.editorSelected = true; this.schedule(); }
      }, {signal});
      document.addEventListener('shopify:section:deselect', e => {
        if (e.target?.contains(this)) { this.editorSelected = false; this.schedule(); }
      }, {signal});
      this.bindSticky(signal);
      this.show(0);
    }
    bindSticky(signal) {
      this.headerGroup = this.closest('#header-group');
      this.sectionWrapper = this.closest('.shopify-section');
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', () => this.syncSticky(), {signal});
      this.barResize = new ResizeObserver(() => this.syncSticky());
      this.barResize.observe(this);
      this.syncSticky();
    }
    syncSticky() {
      if (!this.isConnected) return;
      const sticky = (this.mobileQuery.matches ? this.dataset.stickyMobile : this.dataset.stickyDesktop) === 'true';
      if (!this.headerGroup) {
        this.sectionWrapper?.toggleAttribute('data-cna-standalone-sticky', sticky);
        return;
      }
      const group = this.headerGroup;
      group.cnaAnnouncementOwner = this;
      group.dataset.cnaBehaviour = sticky ? 'sticky' : 'flow';
      const height = `${this.getBoundingClientRect().height}px`;
      if (group.style.getPropertyValue('--cna-ann-height') !== height) group.style.setProperty('--cna-ann-height', height);
    }
    releaseSticky() {
      this.sectionWrapper?.removeAttribute('data-cna-standalone-sticky');
      if (this.headerGroup?.cnaAnnouncementOwner !== this) return;
      this.headerGroup.removeAttribute('data-cna-behaviour');
      this.headerGroup.style.removeProperty('--cna-ann-height');
      delete this.headerGroup.cnaAnnouncementOwner;
    }
    show(next) {
      if (!this.slides?.length) return;
      this.index = Math.max(0, Math.min(next, this.slides.length - 1));
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.events?.signal.aborted) return;
      if (this.pauseButton) {
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        const label = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.querySelector('span').textContent = label;
      }
      const paused = this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.userPaused || this.reduced.matches || this.hovering || this.focused || this.editorSelected || document.hidden;
      if (!paused) this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length), this.interval);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-catalog-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('catalina-catalog-carousel'))customElements.define('catalina-catalog-carousel',class extends HTMLElement{
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.mount())}
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.events?.abort();this.observer?.disconnect();this.resize?.disconnect();this.events=null}
 mount(){if(!this.isConnected||this.events)return;this.events=new AbortController();const signal=this.events.signal;this.track=this.querySelector('[data-track]');this.next=this.querySelector('[data-next]');this.previous=this.querySelector('[data-prev]');this.message=this.querySelector('[data-status]');this.labels=JSON.parse(this.querySelector('[data-labels]').content.textContent);this.limit=Number(this.dataset.limit)||12;
 this.track.addEventListener('scroll',()=>this.progress(),{passive:true,signal});this.next.addEventListener('click',()=>this.move(1),{signal});this.previous.addEventListener('click',()=>this.move(-1),{signal});this.querySelector('[data-retry]').addEventListener('click',()=>this.load(),{signal});this.addEventListener('click',e=>{const save=e.target.closest('[data-save]');if(save)this.saveProduct(save);const add=e.target.closest('[data-add]');if(add)this.addProduct(add)},{signal});document.addEventListener('catalina:saved-products',()=>this.syncSaved(),{signal});window.addEventListener('storage',()=>this.syncSaved(),{signal});this.resize=new ResizeObserver(()=>this.progress());this.resize.observe(this.track);
 this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load()}},{rootMargin:'600px'});this.observer.observe(this)
 }
 async load(){if(this.loading)return;this.loading=true;this.setAttribute('aria-busy','true');this.querySelector('[data-error]').hidden=true;this.querySelector('[data-skeleton]').hidden=false;this.message.textContent='';const loaded=[],seen=new Set(),visited=new Set();let page=1,total=0;
 try{do{if(visited.has(page))throw Error('catalog-pagination');visited.add(page);const url=new URL(this.dataset.catalog,location.origin);url.searchParams.set('section_id','catalina-catalog-feed');url.searchParams.set('sort_by',this.dataset.sort);url.searchParams.set('page',String(page));const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 const response=await fetch(url,{credentials:'same-origin',signal:this.events.signal});if(!response.ok)throw Error('catalog-request');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const node=doc.querySelector('template[data-catalina-catalog-feed]');if(!node)throw Error('catalog-feed-missing');const feed=JSON.parse(node.content.textContent);if(feed.valid!==true||feed.sort!==this.dataset.sort)throw Error('catalog-sort');total=feed.total;
 for(const product of feed.products){if(!seen.has(String(product.id))&&(this.dataset.available!=='true'||product.available)){seen.add(String(product.id));loaded.push(product)}}page=Number(feed.next_page)||0;
 }while(page&&loaded.length<this.limit);
 if(!this.isConnected)return;this.products=loaded.slice(0,this.limit);this.track.replaceChildren(...this.products.map((p,i)=>this.card(p,i)));this.querySelector('[data-skeleton]').hidden=true;this.querySelector('[data-count]').textContent=this.dataset.count==='true'?' '+total:'';this.querySelector('[data-controls]').hidden=this.products.length===0;this.track.hidden=this.products.length===0;this.querySelector('[data-progress]').hidden=this.products.length===0;
 if(!this.products.length){this.message.textContent=this.labels.empty;if(this.dataset.hideEmpty==='true'&&this.dataset.editor!=='true')this.hidden=true}this.syncSaved();requestAnimationFrame(()=>this.progress());this.dataset.loaded='true';
 }catch(error){if(error.name!=='AbortError'&&this.isConnected){this.querySelector('[data-skeleton]').hidden=true;this.querySelector('[data-error]').hidden=false;this.message.textContent=this.labels.error}}
 finally{this.loading=false;this.removeAttribute('aria-busy')}
 }
 card(product,index){const node=this.querySelector('template[data-card]').content.firstElementChild.cloneNode(true);node.dataset.productId=String(product.id);const title=node.querySelector('[data-title]');title.textContent=product.title;title.href=product.url;title.title=product.title;const media=node.querySelector('[data-media]');media.href=product.url;media.setAttribute('aria-label',product.title);const image=node.querySelector('[data-image]');if(product.image){image.src=product.image;image.alt=product.title}else image.remove();const second=node.querySelector('[data-second]');if(product.second_image&&this.dataset.second==='true'){second.src=product.second_image;second.alt=product.title;media.classList.add('cc__media--second')}else second.remove();
 const vendor=node.querySelector('[data-vendor]');if(this.dataset.vendor==='true')vendor.textContent=product.vendor||'';else vendor.remove();node.querySelector('[data-price]').textContent=(product.price_varies?this.labels.from+' ':'')+product.price_html;const options=node.querySelector('[data-options]');if(!product.has_only_default_variant)options.textContent=this.labels.options;else options.remove();
 const badge=node.querySelector('[data-badge]');if(!product.available)badge.textContent=this.labels.soldOut;else if(index===0&&this.labels.badge)badge.textContent=this.labels.badge;else badge.remove();const saved=node.querySelector('[data-save]');if(this.dataset.save==='true'){saved.dataset.productId=String(product.id);saved.setAttribute('aria-label',this.labels.save+': '+product.title)}else saved.remove();
 const quick=node.querySelector('[data-quick]');if(this.dataset.quick!=='true')quick.remove();else if(product.available&&product.has_only_default_variant&&!product.requires_selling_plan&&Number(product.variant?.minimum||1)===1){const button=document.createElement('button');button.type='button';button.className='cc__quick';button.dataset.add=String(product.id);button.setAttribute('aria-label',this.labels.add+': '+product.title);button.append(...quick.childNodes);quick.replaceWith(button)}else{quick.href=product.url;quick.setAttribute('aria-label',this.labels.choose+': '+product.title)}return node
 }
 move(direction){const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;this.track.scrollBy({left:direction*this.track.clientWidth,behavior:reduced?'instant':'smooth'})}
 progress(){if(!this.track)return;const width=this.track.clientWidth,total=this.track.scrollWidth,max=Math.max(0,total-width),position=Math.max(0,this.track.scrollLeft),fraction=total?Math.min(1,width/total):1;this.previous.disabled=position<=1;this.next.disabled=position>=max-1;const thumb=this.querySelector('[data-thumb]');thumb.style.width=(fraction*100)+'%';thumb.style.left=(max?position/max*(1-fraction)*100:0)+'%';this.querySelector('[data-progress]').setAttribute('aria-valuenow',String(Math.round(max?position/max*100:100)))}
 saved(){if(window.catalinaSavedProductsWriteFailed)return window.catalinaSavedProducts||new Set();try{return new Set(JSON.parse(localStorage.getItem('catalina-saved-products-v1')||'[]').map(String))}catch{return window.catalinaSavedProducts||new Set()}}
 saveProduct(button){const saved=this.saved(),id=button.dataset.productId;if(saved.has(id))saved.delete(id);else saved.add(id);window.catalinaSavedProducts=saved;try{localStorage.setItem('catalina-saved-products-v1',JSON.stringify([...saved]));window.catalinaSavedProductsWriteFailed=false}catch{window.catalinaSavedProductsWriteFailed=true}document.dispatchEvent(new CustomEvent('catalina:saved-products'))}
 syncSaved(){const saved=this.saved();this.querySelectorAll('[data-save]').forEach(button=>{const chosen=saved.has(button.dataset.productId);button.setAttribute('aria-pressed',String(chosen));const product=this.products?.find(p=>String(p.id)===button.dataset.productId);button.setAttribute('aria-label',(chosen?this.labels.saved:this.labels.save)+': '+(product?.title||''))})}
 async addProduct(button){if(this.adding)return;const product=this.products.find(p=>String(p.id)===button.dataset.add);if(!product?.variant?.id)return;this.adding=true;this.querySelectorAll('[data-add]').forEach(b=>b.disabled=true);button.setAttribute('aria-busy','true');this.message.textContent='';let accepted=false,deferred,EventClass;
 try{try{({CartLinesUpdateEvent:EventClass}=await import('@shopify/events'));deferred=EventClass.createPromise();deferred.promise.catch(()=>{});this.dispatchEvent(new EventClass({action:'add',context:'product',lines:[{merchandiseId:String(product.variant.id),quantity:product.variant.minimum||1}],promise:deferred.promise}))}catch{}
 const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(n=>n.dataset.sectionId).filter(Boolean))].slice(0,5);const response=await fetch(this.dataset.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:product.variant.id,quantity:product.variant.minimum||1}],sections,sections_url:location.pathname})});const data=await response.json();accepted=response.ok&&!data.status;
 if(deferred){const cartResponse=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!cartResponse.ok)throw Error('cart-refresh');const cart=await cartResponse.json();deferred.resolve({cart:EventClass.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'catalina-catalog-carousel',sourceId:this.id,itemCount:cart.item_count,sections:data.sections,didError:!accepted}})}this.message.textContent=accepted?this.labels.added:this.labels.addError;
 }catch(error){deferred?.reject(error);this.message.textContent=accepted?this.labels.added:this.labels.addError}finally{this.querySelector('[data-bag]').hidden=false;this.adding=false;this.querySelectorAll('[data-add]').forEach(b=>b.disabled=false);button.removeAttribute('aria-busy')}
 }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalina-swipe-carousel')) {
  customElements.define('catalina-swipe-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const track = this.querySelector('[data-ca-track]');
      if (!track) return;

      const mobile = matchMedia('(max-width: 749px)');
      let retryAfter = 0;

      track.addEventListener('scroll', async () => {
        if (!mobile.matches || Date.now() < retryAfter) return;
        const remaining = track.scrollWidth - track.clientWidth - Math.abs(track.scrollLeft);
        if (remaining > track.clientWidth) return;

        const link = this.querySelector('[data-ca-load]');
        if (!link || link.getAttribute('aria-busy') === 'true') return;

        const sectionId = link.dataset.section;
        const nextPath = link.dataset.caLoad;
        const url = new URL(nextPath, location.href);
        url.searchParams.set('sections', sectionId);
        link.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url, { signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Unable to load the next collection page');
          const sections = await response.json();
          if (!sections[sectionId]) throw new Error('Collection section missing from response');

          const doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
          const carousel = doc.querySelector('catalina-swipe-carousel');
          const nextTrack = carousel?.querySelector('[data-ca-track]');
          if (!nextTrack) throw new Error('Collection carousel missing from response');

          const knownIds = new Set(Array.from(track.children, card => card.dataset.productId));
          const cards = document.createDocumentFragment();
          for (const card of Array.from(nextTrack.children)) {
            const id = card.dataset.productId;
            if (id && knownIds.has(id)) continue;
            if (id) knownIds.add(id);
            cards.append(card);
          }
          track.append(cards);

          const nextLink = carousel.querySelector('[data-ca-load]');
          const followingPath = nextLink?.dataset.caLoad;
          if (followingPath && followingPath !== nextPath) {
            link.dataset.caLoad = followingPath;
            link.setAttribute('href', followingPath);
          } else {
            link.remove();
          }
          track.dispatchEvent(new Event('scroll'));
        } catch {
          retryAfter = Date.now() + 2000;
        } finally {
          link.removeAttribute('aria-busy');
        }
      }, { passive: true, signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalina-footer-v6')) {
 customElements.define('catalina-footer-v6', class extends HTMLElement {
  connectedCallback(){this.startFrame=requestAnimationFrame(()=>this.mount());}
  disconnectedCallback(){cancelAnimationFrame(this.startFrame);this.events?.abort();this.removeAttribute('data-ready');}
  mount(){
   if(!this.isConnected||this.dataset.ready==='true')return;
   this.events=new AbortController();const signal=this.events.signal;
   this.columns=[...this.querySelectorAll('[data-cft-column]')];this.mobile=matchMedia('(max-width:749px)');
   this.sync=()=>this.columns.forEach(column=>{column.open=!this.mobile.matches||this.dataset.mobileOpen==='true';const heading=column.querySelector('summary');heading.tabIndex=this.mobile.matches?0:-1;if(this.mobile.matches)heading.removeAttribute('aria-disabled');else heading.setAttribute('aria-disabled','true');});
   this.columns.forEach(column=>column.querySelector('summary').addEventListener('click',e=>{if(!this.mobile.matches)e.preventDefault();},{signal}));
   this.mobile.addEventListener('change',this.sync,{signal});
   document.addEventListener('shopify:block:select',e=>{const column=this.columns.find(c=>c.dataset.blockId===String(e.detail?.blockId));if(column)column.open=true;},{signal});
   this.dataset.ready='true';this.sync();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalina-marquee-v2')) {
  customElements.define('catalina-marquee-v2', class extends HTMLElement {
    connectedCallback() {
      this.window = this.querySelector('[data-cmq-window]');
      this.track = this.querySelector('[data-cmq-track]');
      this.primary = this.querySelector('[data-cmq-primary]');
      this.source = this.querySelector('[data-cmq-source]');
      this.duplicate = this.querySelector('[data-cmq-duplicate]');
      this.button = this.querySelector('[data-cmq-toggle]');
      if (!this.window || !this.source || !this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverMedia = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      this.mobileMedia = matchMedia('(max-width: 749px)');
      this.manualPaused = false; this.userPlay = false; this.hovered = false; this.visible = true; this.editorPaused = false;
      this.button.addEventListener('click', () => this.toggle(), options);
      this.window.addEventListener('keydown', event => {
        if (event.target === this.window && (event.key === ' ' || event.key === 'Enter')) { event.preventDefault(); this.toggle(); }
      }, options);
      this.window.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && this.hoverMedia.matches && this.dataset.pauseHover === 'true') { this.hovered = true; this.sync(); }
      }, options);
      this.window.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.hoverMedia.addEventListener('change', () => { this.hovered = false; this.sync(); }, options);
      this.reduce.addEventListener('change', () => { this.userPlay = false; this.sync(); }, options);
      this.mobileMedia.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pageshow', () => { this.schedule(); this.sync(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        const item = [...this.source.querySelectorAll('[data-cmq-block-id]')].find(node => node.dataset.cmqBlockId === id || node === event.target || node.contains(event.target));
        if (!item) return;
        this.editorPaused = true;
        if (this.animation && this.distance) {
          const offset = Math.max(0, item.offsetLeft - 20), progress = Math.min(.999, offset / this.distance);
          this.animation.currentTime = (this.dataset.direction === 'reverse' ? 1 - progress : progress) * this.duration;
        }
        this.sync();
      }, options);
      document.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.sync(); }, options);
      this.resize = new ResizeObserver(() => this.schedule()); this.resize.observe(this.window); this.resize.observe(this.source);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }); this.intersection.observe(this);
      document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.dataset.cmqReady = 'true'; this.schedule();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.intersection?.disconnect(); this.animation?.cancel(); this.animation = null; this.signature = null; cancelAnimationFrame(this.frame); }
    schedule() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.measure()); }
    clone(node) {
      const copy = node.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); copy.setAttribute('inert', ''); copy.removeAttribute('data-cmq-source'); copy.dataset.cmqFill = '';
      [copy, ...copy.querySelectorAll('*')].forEach(element => { element.removeAttribute('id'); element.removeAttribute('data-shopify-editor-block'); element.removeAttribute('data-cmq-block-id'); });
      return copy;
    }
    measure() {
      if (!this.isConnected) return;
      if (this.dataset.enabled !== 'true') {
        this.animation?.cancel(); this.animation = null; this.primary.querySelectorAll('[data-cmq-fill]').forEach(node => node.remove()); this.duplicate.replaceChildren(); this.sync(); return;
      }
      const base = this.source.getBoundingClientRect().width, viewport = this.window.clientWidth;
      if (base <= 0 || viewport <= 0) return;
      const duration = Math.max(10, Math.min(80, Number(this.mobileMedia.matches ? this.dataset.speedMobile : this.dataset.speed) || 35)) * 1000;
      const repeats = Math.max(1, Math.ceil((viewport + 1) / base));
      const signature = `${base.toFixed(3)}|${viewport}|${repeats}|${duration}|${this.dataset.direction}`;
      if (signature === this.signature && this.animation) return;
      this.signature = signature;
      const progress = this.animation && this.duration ? (Number(this.animation.currentTime || 0) % this.duration) / this.duration : 0;
      this.animation?.cancel(); this.primary.querySelectorAll('[data-cmq-fill]').forEach(node => node.remove());
      for (let i = 1; i < repeats; i++) this.primary.append(this.clone(this.source));
      this.duplicate.replaceChildren(...[...this.primary.children].map(node => this.clone(node)));
      this.distance = this.primary.getBoundingClientRect().width; this.duration = duration;
      const first = 'translate3d(0,0,0)', last = `translate3d(${-this.distance}px,0,0)`;
      this.animation = this.track.animate([{ transform: this.dataset.direction === 'reverse' ? last : first }, { transform: this.dataset.direction === 'reverse' ? first : last }], { duration, iterations: Infinity, easing: 'linear' });
      this.animation.currentTime = progress * duration; this.sync();
    }
    toggle() {
      if (this.dataset.enabled !== 'true') return;
      if (this.manualPaused || (this.reduce.matches && !this.userPlay)) { this.manualPaused = false; this.userPlay = true; }
      else this.manualPaused = true;
      this.sync();
    }
    sync() {
      if (!this.button || !this.reduce) return;
      const enabled = this.dataset.enabled === 'true', intentionalPause = this.manualPaused || (this.reduce.matches && !this.userPlay);
      const pause = !enabled || intentionalPause || this.hovered || !this.visible || this.editorPaused || document.hidden;
      if (this.animation) { if (pause) this.animation.pause(); else this.animation.play(); }
      this.dataset.cmqPaused = String(pause); this.dataset.cmqReduced = String(this.reduce.matches);
      this.button.hidden = !enabled || (this.dataset.showControl !== 'true' && !this.reduce.matches);
      const label = intentionalPause ? 'Play marquee' : 'Pause marquee'; this.button.setAttribute('aria-label', label); this.button.title = label;
      this.button.querySelector('[data-cmq-play]').hidden = !intentionalPause; this.button.querySelector('[data-cmq-pause]').hidden = intentionalPause;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-pdp-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ca-pdp-bundle-v2')) {
 customElements.define('ca-pdp-bundle-v2', class extends HTMLElement {
  connectedCallback() { this.startFrame=requestAnimationFrame(()=>this.mount()); }
  mount() {
    if (this.abort) return;
    this.abort = new AbortController();
    this.addEventListener('change', () => this.update(), { signal: this.abort.signal });
    this.addEventListener('click', e => { if (e.target.closest('[data-add]')) this.add(); }, { signal: this.abort.signal });
    if (this.dataset.auto === 'true') this.load(); else this.enhance();
  }
  disconnectedCallback() { cancelAnimationFrame(this.startFrame); this.abort?.abort(); this.abort = null; }
  async load() {
    try {
      const response = await fetch(this.dataset.url, { signal: this.abort.signal });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = [...doc.querySelectorAll('ca-pdp-bundle-v2')].find(n => n.dataset.section === this.dataset.section);
      if (fresh && this.isConnected) { this.innerHTML = fresh.innerHTML; this.dataset.auto = 'false'; this.enhance(); }
    } catch (_) {  }
  }
  enhance() { this.querySelectorAll('[data-enhanced]').forEach(n => { n.hidden = false; }); this.update(); }
  money(cents) { return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'AED' }).format(cents / 100); }
  selection() {
    return [...this.querySelectorAll('.cv2-pick')].flatMap(card => {
      const option = card.querySelector('[data-variant]')?.selectedOptions[0];
      return option && !option.disabled && card.querySelector('[data-pick]')?.checked ? [{ id: option.value, quantity: Number(option.dataset.quantity) || 1, price: Number(option.dataset.price) }] : [];
    });
  }
  update() {
    this.querySelectorAll('[data-variant], [data-pick]').forEach(control => { control.disabled = !!this.busy; });
    this.querySelectorAll('.cv2-pick').forEach(card => {
      const option = card.querySelector('[data-variant]')?.selectedOptions[0];
      if (!option) return;
      card.querySelector('[data-price]').textContent = this.money(Number(option.dataset.price));
      card.querySelector('[data-quantity-display]').textContent = option.dataset.quantity || '1';
    });
    const items = this.selection();
    const total = this.querySelector('[data-total]');
    if (total) total.textContent = this.money(items.reduce((sum, item) => sum + item.price * item.quantity, 0));
    const button = this.querySelector('[data-add]');
    if (button) button.disabled = !!this.busy || !items.length;
  }
  async add() {
    if (this.busy) return;
    const items = this.selection().map(({ id, quantity }) => ({ id, quantity }));
    if (!items.length) return;
    this.busy = true; this.update();
    const button = this.querySelector('[data-add]'), status = this.querySelector('.cv2-status'), bag = this.querySelector('.cv2-view-bag');
    button.textContent = this.dataset.loading; this.setAttribute('aria-busy', 'true'); status.textContent = '';
    let deferred, EventClass, accepted = false, responseData;
    try {
      try {
        ({ CartLinesUpdateEvent: EventClass } = await import('@shopify/events'));
        deferred = EventClass.createPromise();
        deferred.promise.catch(() => {});
        this.dispatchEvent(new EventClass({ action: 'add', context: 'product', lines: items.map(i => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: deferred.promise }));
      } catch (_) {  }
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
      responseData = await response.json();
      accepted = response.ok && !responseData.status;
      const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      deferred?.resolve({ cart: EventClass.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'catalina-product-bundle', sourceId: this.dataset.section, itemCount: cart.item_count, sections: responseData.sections, didError: !accepted } });
      status.textContent = accepted ? this.dataset.success : this.dataset.error;
    } catch (error) {
      deferred?.reject(error);
      status.textContent = accepted ? this.dataset.success : this.dataset.error;
    } finally {
      bag.hidden = false;
      if (accepted) this.querySelectorAll('[data-pick]').forEach(input => { input.checked = false; });
      this.busy = false; button.textContent = this.dataset.addLabel; this.removeAttribute('aria-busy'); this.update();
    }
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-pdp-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('catalina-product-faq'))customElements.define('catalina-product-faq',class extends HTMLElement{connectedCallback(){this.frame=requestAnimationFrame(()=>{if(!this.isConnected||this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.addEventListener('toggle',e=>{const item=e.target;if(this.dataset.single==='true'&&item.matches('details[open]'))this.querySelectorAll('details[open]').forEach(other=>{if(other!==item)other.open=false})},{capture:true,signal});document.addEventListener('shopify:block:select',e=>{const row=[...this.querySelectorAll('details')].find(n=>n.dataset.blockId===String(e.detail?.blockId));if(row)row.open=true},{signal})})}disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort?.abort();this.abort=null}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-pdp-polish"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('catalina-variant-visuals-v4')){
 customElements.define('catalina-variant-visuals-v4',class extends HTMLElement{
  connectedCallback(){
   try{this.data=JSON.parse(this.querySelector('template[data-cav4-data]')?.content.textContent||'{}')}catch{return}
   this.apply=()=>{
    const roots=[...document.querySelectorAll('.product-information variant-picker')].filter(el=>String(el.dataset.productId)===String(this.data.product));
    for(const picker of roots)for(const group of picker.querySelectorAll('fieldset')){
     const choices=[...group.querySelectorAll('input[data-option-name]')];
     if(!choices.length)continue;
     const option=this.data.options?.find(x=>x.name===choices[0].dataset.optionName);if(!option)continue;
     const distinct=new Set(option.values.filter(x=>x.photo&&x.photoId).map(x=>String(x.photoId)));
     const usePhotos=this.dataset.usePhotos!=='false'&&this.data.imageCount>1&&distinct.size>1;
     group.classList.add('cav4-group');
     for(const input of choices){
      const info=option.values.find(x=>x.raw===input.value);const label=input.closest('label.variant-option__button-label');
      if(!info||!label)continue;
      const photo=usePhotos?info.photo:null;const paint=info.paint||'';
      const token=JSON.stringify([input.value,photo,paint,this.dataset.labels]);
      if(label.dataset.cav4Token===token&&label.querySelector('.cav4-visual'))continue;
      label.querySelectorAll('.cav4-visual,.cav4-caption').forEach(el=>el.remove());
      label.classList.add('cav4-choice');label.classList.toggle('cav4-photo',!!photo);label.classList.toggle('cav4-text',!photo&&!paint);
      const visual=document.createElement('span');visual.className='cav4-visual';visual.setAttribute('aria-hidden','true');
      if(photo){const image=document.createElement('img');image.src=photo;image.width=180;image.height=180;image.alt='';image.loading='lazy';visual.append(image)}
      else if(paint)visual.style.background=paint;
      else visual.textContent=info.raw;
      label.append(visual);
      if(this.dataset.labels!=='false'&&(photo||paint)){const caption=document.createElement('span');caption.className='cav4-caption';caption.textContent=info.raw.replace(/(?:[-_]\d+)+$/,'').replaceAll('-',' ');label.append(caption)}
      label.title=info.raw;label.dataset.cav4Token=token;
     }
    }
   };
   this.schedule=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.apply()})};
   this.observer=new MutationObserver(records=>{if(records.some(r=>r.target instanceof Element&&r.target.closest('.product-information')&&!r.target.closest('.cav4-visual,.cav4-caption')))this.schedule()});
   this.observer.observe(document.body,{childList:true,subtree:true});this.schedule();
  }
  disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalina-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('catalina-reviews-v1')){
 customElements.define('catalina-reviews-v1',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
   const rail=this.querySelector('[data-car-track]'),prev=this.querySelector('[data-car-previous]'),next=this.querySelector('[data-car-next]'),status=this.querySelector('[data-car-status]');if(!rail)return;
   const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;
   this.update=()=>{const distance=Math.abs(rail.scrollLeft),end=rail.scrollWidth-rail.clientWidth,card=rail.querySelector('.car__card'),step=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap):1;if(prev)prev.disabled=distance<3;if(next)next.disabled=distance>=end-3;if(status)status.textContent=`${Math.min(rail.children.length,Math.round(distance/step)+1)} / ${rail.children.length}`};
   const move=direction=>{const rtl=getComputedStyle(rail).direction==='rtl';rail.scrollBy({left:direction*(rtl?-1:1)*rail.clientWidth,behavior:reduced()?'instant':'smooth'})};
   prev?.addEventListener('click',()=>move(-1),{signal});next?.addEventListener('click',()=>move(1),{signal});rail.addEventListener('scroll',this.update,{signal,passive:true});
   this.observer=new ResizeObserver(this.update);this.observer.observe(rail);requestAnimationFrame(this.update);
   document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target)){event.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});this.update()}},{signal});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
